import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78f81a1b&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=78f81a1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f81a1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f81a1b')) {
      api.createRecord('78f81a1b', component.options)
    } else {
      api.reload('78f81a1b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=78f81a1b&scoped=true&lang=pug&", function () {
      api.rerender('78f81a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/emailInput/index.vue"
export default component.exports